import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import type { AccessGroup } from 'types/client.types';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  options?: AccessGroup[];
}

const AccessGroupCombobox = ({ isMulti = false, onValueChange, value, disabled = false, options, ...props }: Props) => {
  const { t } = useTranslation('common');

  if (!options) {
    return null;
  }

  return (
    <div {...props}>
      <HubertCombobox
        itemName={t('accessGroup.itemName')}
        isMulti={isMulti}
        items={options.map((x) => {
          return { ...x, label: x.name, value: x.id };
        })}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default AccessGroupCombobox;
